import API from './request'
import Storage from './storage'
import Base64 from './base64'
import Store from '@/store/index'
import Utils from './utils'

const AppId = process.env.Wechat_AppId

export default {

    isReady: Utils.readyable(),

    async getOpenId() {
        let search = new URL(location.href).searchParams
        let code = search.get('code')
        let preCode = Storage.get('preCode')
        try {
            if (code && !preCode) {
                Storage.set('preCode', code)
                let { data } = await API.get(`/wx/mp/${AppId}/code2openid`, {
                    code
                })
                Storage.set('token', data.accessToken)
                Store.commit('setUserInfo', JSON.parse(Base64.decode(data.accessToken.split('.')[1])))
                this.isReady.ready()
            } else {
                if (navigator.userAgent.match(/MicroMessenger/gi)) {
                    Storage.set('preCode', '')
                    this.redirectAuthPage()
                } else {
                    this.isReady.cancel(new Error('notinwx'))
                }
            }
        } catch (error) {
            this.isReady.cancel(error)
        }
    },

    redirectAuthPage() {
        let info = new URL('https://open.weixin.qq.com/connect/oauth2/authorize#wechat_redirect')
        let urlInfo = new URL(location.href)
        urlInfo.searchParams.delete('code')
        urlInfo.searchParams.delete('state')
        let params = {
            appid: AppId,
            redirect_uri: urlInfo.toString(),
            response_type: 'code',
            scope: 'snsapi_base',
            state: ''
        }
        Object.keys(params).map(key => {
            info.searchParams.append(key, params[key])
        })
        location.href = info.toString()
    },

    async getSignUpQrcode(form) {
        // http://localhost:8812/wx/miniqrcode/wx59ae5f1addefd9ea/getSignupCode
        let { data } = await API.post(`/wx/miniqrcode/wx59ae5f1addefd9ea/getSignupCode`, form)
        return data
    }

}